'use client';

import React, { memo, useMemo } from 'react';
import AppIcon from './AppIcon';
import AppImage from './AppImage';

interface AppLogoProps {
  src?: string;
  iconName?: string;
  size?: number;
  className?: string;
  onClick?: () => void;
}

const AppLogo = memo(function AppLogo({
  src = '/assets/images/ChatGPT_Image_Aug_8__2026__08_38_46_PM-1786214499973.png',
  iconName = 'SparklesIcon',
  size = 64,
  className = '',
  onClick,
}: AppLogoProps) {
  const isFullHeight = className?.includes('h-full');

  const containerClassName = useMemo(() => {
    const classes = ['flex items-center'];
    if (isFullHeight) classes.push('h-full');
    if (onClick) classes.push('cursor-pointer hover:opacity-80 transition-opacity');
    if (className && !isFullHeight) classes.push(className);
    return classes.join(' ');
  }, [onClick, className, isFullHeight]);

  return (
    <div className={containerClassName} onClick={onClick}>
      {src ? (
        <AppImage
          src={src}
          alt="Logo"
          width={size}
          height={size}
          style={{ width: 'auto', height: size }}
          className="flex-shrink-0 object-contain"
          priority={true}
          unoptimized={src.endsWith('.svg')}
        />
      ) : (
        <AppIcon name={iconName} size={size} className="flex-shrink-0" />
      )}
    </div>
  );
});

export default AppLogo;
